<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        
       <div class="card">
        
            <div class="card-body">
              <h5>{{this.currentLanguage ==='en'?'How to apply for running event registration type #1':'วิธีการสมัคร ลงทะเบียนงานวิ่งรูปแบบที่ #1'}}</h5>
              <hr>
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 100%;border-radius: 2em;"
                  src="../../assets/images/running/howtoregisv1.jpg"
                />
              </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
               <h5>{{this.currentLanguage ==='en'?'How to apply for running event registration type #2':'วิธีการสมัคร ลงทะเบียนงานวิ่งรูปแบบที่ #2'}}</h5>
              <hr>
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 100%;border-radius: 2em;"
                  src="../../assets/images/running/howtoregisv2.jpg"
                />
              </div>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => `;วิธีการสมัคร-ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
      meta: [
        {
          name: `description`,
          content: computed(() => `ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
        },
        {
          name: `keywords`,
          content: computed(() => `เกี่ยวกับเรา,ระบบรับสมัครงานวิ่ง,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,runrace,runninghub`),
        }
        ],
     
    })
  },
   data() {
    return {
      currentLanguage: 'th',
    };
  },
  async mounted() {
    if(localStorage.getItem('currentLanguage') !== null){
      this.currentLanguage = localStorage.getItem('currentLanguage');
    }
  }


};
</script>